import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SignupWizardService } from '../signup-wizard.service';

function confirmPass(group: UntypedFormGroup) {
  group
    .get('confirm')
    .setErrors(group.get('password').value !== group.get('confirm').value ? { mismatch: true } : null);
  return null;
}

@Component({
  standalone: false,
  selector: 'sbnb-signup-password',
  templateUrl: './signup-password.component.html',
  styleUrls: ['./signup-password.component.scss'],
})
export class SignupPasswordComponent implements OnInit {
  formGroup: UntypedFormGroup;
  saving: boolean;

  constructor(private wizard: SignupWizardService) { }

  ngOnInit() {
    if (!this.wizard.signupUser.token) {
      this.wizard.cancel();
    }

    this.formGroup = new UntypedFormGroup(
      {
        password: new UntypedFormControl('', {
          validators: [Validators.required, Validators.minLength(8)],
        }),
        confirm: new UntypedFormControl('', { validators: [Validators.required] }),
      },
      { validators: confirmPass }
    );
  }

  next() {
    if (!this.formGroup.valid) {
      return;
    }

    this.saving = true;
    this.wizard
      .updatePassword(this.formGroup.controls.password.value, this.formGroup.controls.confirm.value)
      .subscribe((res) => {
        if ('error' in res) {
          this.saving = false;
          return;
        }

        this.saving = false;
        this.wizard.next();
      });
  }
}
